import React from 'react';
import { motion } from 'framer-motion';
import gestionBatiment1 from '../Assets/gbatiment.png';
import gestionBatiment2 from '../Assets/gbatiment1.png';
import './Gestionbatiment.css';

const GestionBatiments = () => {
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="gestion-batiments-wrapper">
      <div className="gestion-batiments-container">
        <h1 className="simple-title">Gestion des Bâtiments</h1>
        <div className="imagebatiment">
          <div className="solution-content">
            {[
              {
                image: gestionBatiment1,
                alt: 'Gestion Bâtiments 1',
                description:
                  'Nos solutions optimisent la gestion énergétique de vos bâtiments en surveillant en temps réel la consommation électrique, thermique et hydrique.',
                reverse: false,
              },
              {
                image: gestionBatiment2,
                alt: 'Gestion Bâtiments 2',
                description:
                  'Améliorez la sécurité et le confort des occupants grâce à des systèmes intelligents de contrôle d’accès, de climatisation et d’éclairage automatisé.',
                reverse: true,
              },
            ].map((block, index) => (
              <div key={index} className={`solution-block ${block.reverse ? 'reverse' : ''}`}>
                <motion.div
                  className="solution-block-image-container"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={imageVariants}
                  custom={index}
                >
                  <img src={block.image} alt={block.alt} className="solution-block-image" />
                </motion.div>
                <motion.div
                  className="solution-block-text-container"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={textVariants}
                  custom={index}
                >
                  <p className="solution-block-description">{block.description}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GestionBatiments;